import { render, staticRenderFns } from "./painel-usuario-espelho.vue?vue&type=template&id=0e61c75c&scoped=true"
import script from "./painel-usuario-espelho.vue?vue&type=script&lang=ts"
export * from "./painel-usuario-espelho.vue?vue&type=script&lang=ts"
import style0 from "./painel-usuario-espelho.vue?vue&type=style&index=0&id=0e61c75c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e61c75c",
  null
  
)

export default component.exports